export default class LocalScaleManager {
    static scaleSprite (sprite, availableSpaceWidth, availableSpaceHeight, padding, scaleMultiplier, isFullScale) {
        /* We are passing an additional parameter “isFullScreen”
        * which will stretch sprite to fit into the available space if available width and height is more than the sprite size.
        */
        let scale = this.getSpriteScale(sprite.frame.width, sprite.frame.height, availableSpaceWidth, availableSpaceHeight, padding, isFullScale, sprite);
        sprite.setScale(scale * scaleMultiplier);
        return scale;
    }
    static scaleSpriteTo (sprite, scale) {
        sprite.setScale(scale);
    }
    static scaleText (sprite, availableSpaceWidth, availableSpaceHeight, padding, scaleMultiplier, isFullScale) {
        let originalWidth = sprite.width;
        let originalHeight = sprite.height;
        let scale = this.getSpriteScale(originalWidth, originalHeight, availableSpaceWidth, availableSpaceHeight, padding, isFullScale , sprite);
        sprite.setScale(scale * scaleMultiplier);
    }
    static scaleBitMapText (sprite, availableSpaceWidth, availableSpaceHeight, padding, scaleMultiplier, isFullScale) {
        let originalWidth = sprite.getData("width");
        let originalHeight = sprite.getData("height");
        let scale = this.getSpriteScale(originalWidth, originalHeight, availableSpaceWidth, availableSpaceHeight, padding, isFullScale , sprite);
        sprite.setScale(scale * scaleMultiplier);
    }

     /* We look at both height and width of the element to see which part is exceeding the available space,
      * take that scale and apply to both width and height to scale entire element in proportion.
      * If element can fit in the space available then there is no need to scale.
      * Just use the element in its original size and put it in its space.
      */
    static getSpriteScale (spriteWidth, spriteHeight, availableSpaceWidth, availableSpaceHeight, minPadding, isFullScale, sprite) {
        let ratio = 1;
        /* Mobile devices actually have more pixels than the logical resolution we define in our code so
         * if we are coding for 200px, a device with devicePixelRatio of 2 would display it using 400px.
         * For pc devicePixelRatio is 1 so desktops are fine with using logical pixels.
         * Mobile devices having devicePixelRatio greater than 1 automatically convert logical value accordingly to the devicePixelRatio.
         * We should consider this value in calculation of the scale so that we have maximum utilization of the available space in terms of pixels.
         */
        let currentDevicePixelRatio = window.devicePixelRatio;
        /** Sprite needs to fit in either width or height */
        let widthRatio = (spriteWidth * currentDevicePixelRatio + 2 * minPadding) / availableSpaceWidth;
        let heightRatio = (spriteHeight * currentDevicePixelRatio + 2 * minPadding) / availableSpaceHeight;
        if (widthRatio > 1 || heightRatio > 1) {
            ratio = 1 / Math.max(widthRatio, heightRatio);
        } else {
            if (isFullScale)
                ratio = 1 / Math.max(widthRatio, heightRatio);
        }
        return ratio * currentDevicePixelRatio;
    }

}
